<template>
    <div ref="modal" class="modal" tabindex="-1" role="dialog" @hidden="hidden">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title text-center"> <b>{{obj.xtitle}}</b> </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-left">
                <Alertas ref="alertar" />
                <table class="table table-condensed table-striped table-hover">
                    <tbody>
                        <tr> <td><b>Estudiante: </b></td> <td>{{parseEstudiante(inscripcion.estudiante)}}</td> </tr>
                        <tr> <td><b>Domicilio: </b></td> <td>{{ inscripcion.estudiante.domicilio }}</td> </tr>
                        <tr> <td><b>Telefono 1: </b></td> <td>{{ inscripcion.estudiante.telefono1 }}</td> </tr>
                        <tr> <td><b>Telefono 2: </b></td> <td>{{ inscripcion.estudiante.telefono2 }}</td> </tr>
                        <tr> <td><b>Correo: </b></td> <td>{{ inscripcion.estudiante.email }}</td> </tr>
                        <tr> <td><b>Ciudad de residencia: </b></td> <td>{{ parseRedidencia(inscripcion.estudiante.ciudad) }}</td> </tr>
                        <tr> <td><b>Estado: </b></td> <td> {{parseEstadoIns(inscripcion.estado_ins)}} </td> </tr>
                        <tr> <td><b>Fecha Registro: </b></td> <td> {{parseFecha(inscripcion.fecha_registro)}} </td> </tr>
                        <tr> <td><b>Observaciones: </b></td> <td> {{inscripcion.observaciones}} </td> </tr>
                    </tbody>
                </table>
            </div>

            
            <div class="modal-footer">
                <!-- <button @click="submit" v-if="activo" type="button" class="btn btn-azul">Aceptar</button> -->
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
import Alertas from '@/components/AAlertas.vue'
import {parseJsonError} from '@/components/Utils.js'
    export default {
        props: {
            obj:{ // {xid:Number,xtitle:String,xbody:String,xsql:Object}
                type: Object,
                required: true
            },
        },
        data(){
            return{
                activo: true,
                inscripcion: {
                    estudiante:{},
                    matricula:{},
                    cuotas_canceladas: []
                },
            }
        },
        watch:{
            'obj.xid': function(){ 
              if( this.obj.xid == null ) return;
              this.$refs.alertar.cargando(); 
              this.activo = true;
              this.getDatos( this.obj.xsql );
            }
        },
        components:{Alertas},
        methods:{
            hidden(){ this.$refs.alertar.cargando(); },
            async getDatos( sql ){
                this.inscripcion = { matricula:{},cuotas_canceladas: [] },
                
              await this.$apollo.query({
                query: sql,
              }).then((data) => {
                //   window.console.log( "DATA ",data.data)
                  this.obj.xid = null;
                  this.inscripcion = data.data.getInscripcion;
                  this.$refs.alertar.reset(); 
              }).catch((error) => {
                  window.console.error(error)
                  this.$notify( parseJsonError( error,'getInscripcion' ) )
              });
            },
            parseEstudiante( e ){
              if( e == null ) return "";
              if( !e.seg_apellido ) e.seg_apellido = '';
              return e.nombres+' '+e.pri_apellido+' '+e.seg_apellido;
            },
            parseEstadoIns( est ){
                if( est == 1 ) return "Inscrito";
                else if( est == 0 ) return "Pre Inscrito";
                else if( est == null ) return "Pre Inscrito";
                else return "Otro "+est;
            },
            parseRedidencia( c ){
                if( !c ) return '';
                if( !c.departamento ) c.departamento = {nombre:'-'};
                return c.nombre + ' ( '+c.departamento.nombre+' )'
            },
            parseFecha( f ){
                if( f == null ) return "Aun no registrado.";
                var date = new Date( f );
                var a = date.getFullYear();
                if( isNaN(a) ) return "No registrado como inscrito.";
                var m = date.getMonth()+1;
                var d = date.getDate();
                var h = date.getHours();
                var mm = date.getMinutes()
                if( m < 10 ) m = '0'+m;
                if( d < 10 ) d = '0'+d;
                if( mm < 10 ) mm = '0'+mm;
                return d+'/'+m+'/'+a+'  '+h+':'+mm;
            },
            submit(){
                // window.console.log( "ZZZZ ",this.obj.xsql,typeof(this.obj.xsql) );
                var vue = this;
                vue.$refs.alertar.cargando();
                vue.activo = false;

                this.$apollo.mutate({
                    mutation: vue.obj.xsql,
                }).then((data) => {
                    window.console.log(data);
                    vue.$refs.alertar.success();
                    this.$emit('exito')
                }).catch((error) => {
                    window.console.error(error);
                    vue.$refs.alertar.invalido();
                })
            }
        },
    
    }
</script>